module.exports = __webpack_public_path__ + "img/13.2c185139.jpg";